import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  list: {
    minHeight: '100vh',
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  row: {
    height: '90px',
    borderBottom: `1px solid ${theme.palette.grey[700]}`,
    backgroundColor: theme.palette.grey[900],
  },
  emptyRow: {
    height: '90px',
  },
  loadingContainer: {
    height: '10vh',
  },
  loading: {
    display: 'table',
    margin: '0 auto',
  },
  buttonContainer: {
    width: '100%',
    padding: theme.spacing(3.5),
    display: 'flex',
    justifyContent: 'center',
  },
  placeholder: {
    textAlign: 'center',
    margin: theme.spacing(3),
  },
}));

export default useStyles;
